import React, { Component, useEffect, useState } from "react";
import { Grid, Row, Col, ControlLabel, FormGroup } from "react-bootstrap";
import Select from "react-select";

import Card from "components/Card/Card.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import { GetAllSuppliers } from "../../../Listfunction";
import axios from "axios";
import ScreenLoader from "views/Components/screenLoader";

const AddProductList = (props) => {
  const [selectSupplier, setselectSupplier] = useState("");
  const [supplierError, setsupplierError] = useState("");
  const [attachmentError, setattachmentError] = useState("");
  const [btnText, setbtnText] = useState("Submit");
  const [profile, setprofile] = useState("");
  const [message, setMessage] = useState("");
  const [isLoading, setisLoading] = useState(false);
  const [btnDisabled, setbtnDisabled] = useState(true);
  const [errormessages, seterrormessages] = useState([]);
  const [supplierDetails, setsupplierDetails] = useState([]);
  const [errors, seterrors] = useState([]);
  const [selectedFile, setselectedFile] = useState([]);

  useEffect(() => {
    console.log("hii");
    allSuppliers();
  }, []);

  const allSuppliers = async () => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    await GetAllSuppliers(obj).then((res) => {
      const suppliers = res.data.data.map((supplier) => ({
        value: supplier.id,
        label: supplier.name,
      }));
      setsupplierDetails(suppliers);
    });
  };

  const handleChange = (selectedOption) => {
    setselectSupplier(selectedOption);
    setsupplierError(null);
    if(profile != ""){
      setbtnDisabled(false)
    }
  };

  const handleFileChange = (event) => {
    setprofile(event.target.files[0]);
    if (selectSupplier != "") {
      setbtnDisabled(false);
    }
  };

  const onSubmit = async () => {
    seterrormessages([]);
    let error = false;
    if (!selectSupplier || selectSupplier == "") {
      error = true;

      setsupplierError(
        <small className="text-danger">Supplier is required.</small>
      );
      setbtnDisabled(true);
    }
    if (profile.length === 0) {
      error = true;
      setattachmentError(
        <small className="text-danger">Attachment is required.</small>
      );
      setbtnDisabled(true);
    }

    if (!error) {
      setisLoading(true);
      var token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;

      const fdata = new FormData();
      fdata.append("csv_file", profile);

      let url = `${
        process.env.REACT_APP_NOT_SECRET_CODE
      }/medicationList/import/csv?supplier_id=${
        selectSupplier.value ? selectSupplier.value : ""
      }`;
      await axios
        .post(url, fdata, {
          headers: {
            Authorization: "Bearer " + obj,
            "X-Country-Code": "BD",
            "X-Client-Name": "WEBSITE",
            "X-Client-Version": "123",
            "Content-Type": "application/json",
            "X-Request-Id": "124",
          },
        })
        .then((res) => {
          console.log("res.data.success", res.status);
          setMessage(res.data.message);
          console.log(res, "result");
          if (res.data.success) {
            //this.handleSuccess("bl")
          }
          setMessage(res.data.message);
          setbtnText("Submit");
          setbtnDisabled(false);
          setprofile("");
          setselectSupplier("");
          props.history.push("/admin/ProductList");
        })
        .catch((err) => {
          console.log("!!!!!", err.response.data.message);
          setattachmentError(<small className="text-danger">{err.response.data.message}</small>)
        });
    }
    setisLoading(false);
  };

  const upload = () => {
    document.getElementById("selectImage").click();
  };

  const onDownload = (e) => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    alert("on downlaod butto clicked");
    const link = document.createElement("a");
    link.href =
      "https://flash-prod.s3.ap-south-1.amazonaws.com/bulk-products-template/SampleDoc.csv";
    link.target = "_blank";
    link.click();
  };

  return (
    <div className="main-content">
      <Grid fluid>
        <Row style={{ height: "70vh" }}>
          <Col md={6}>
            <Card
              content={
                <form>
                  {errormessages.length != 0 && (
                    <div className=" alert alert-danger">
                      {errormessages.map((data) => (
                        <React.Fragment>
                          <li>{data}</li>
                        </React.Fragment>
                      ))}
                    </div>
                  )}
                  <Row>
                    <Col md={12}>
                      <FormGroup>
                        <ControlLabel> Select Supplier</ControlLabel>
                        <Select
                          name="selectSupplier"
                          value={selectSupplier}
                          onChange={handleChange}
                          options={supplierDetails}
                          placeholder="Select Supplier"
                        />
                        {supplierError}
                      </FormGroup>
                      <br />
                      <br />
                      <FormGroup>
                        <ControlLabel>Production List Excel</ControlLabel>
                        <br></br>
                        <input
                          style={{ display: "none" }}
                          id="selectImage"
                          type="file"
                          className="form-control"
                          name="profile"
                          onChange={handleFileChange}
                        />
                        <Button
                          onClick={() => upload()}
                          style={{ color: "#2B3A41" }}
                        >
                          {" "}
                          <i
                            className={
                              profile == ""
                                ? "fa fa-plus"
                                : "fa fa-pencil fa-fw"
                            }
                          ></i>{" "}
                          {profile == "" ? "Choose Excel" : "Change Excel"}
                        </Button>
                      </FormGroup>
                      <div>
                        {errors.length != 0 && (
                          <React.Fragment>
                            <h5>Errors</h5>
                            <ul>
                              {errors.map((index) => {
                                return <li>{index}</li>;
                              })}
                            </ul>
                          </React.Fragment>
                        )}
                      </div>
                      <div>
                        <br />
                        <Button
                          class="btn-color"
                          disabled={btnDisabled}
                          onClick={onSubmit}
                          fill
                        >
                          {btnText}
                        </Button>
                        &nbsp;&nbsp;
                        <Button class="btn-color" onClick={onDownload} fill>
                          Download Sample Excel
                        </Button>
                      </div>
                      {attachmentError}
                    </Col>
                  </Row>
                </form>
              }
            />
          </Col>
        </Row>
      </Grid>
      {isLoading ? <ScreenLoader /> : ""}
    </div>
  );
};

export default AddProductList;
